// Utility to format percentages used across the app.
// formatPercent(value, total?, decimals) returns a string like "12.3%".

export function formatPercent(
  value: number | string | undefined,
  total?: number | string | undefined,
  decimals = 1,
): string {
  const toNumber = (v: any) => {
    if (v === null || v === undefined || v === '') return 0
    const n = Number(v)
    return Number.isFinite(n) ? n : 0
  }

  const num = toNumber(value)

  if (total !== undefined) {
    const den = toNumber(total)
    const percent = den > 0 ? (num / den) * 100 : 0
    return `${percent.toFixed(decimals)}%`
  }

  // If value appears to be a fraction (0..1), convert to percent. Otherwise assume it's already a percent (e.g. 12.3)
  const percent = num <= 1 ? num * 100 : num
  return `${percent.toFixed(decimals)}%`
}
